const errors: { [key: string]: string } = {
  INVALID_PARAMS: 'Error: Invalid params',
  TOKEN_DOES_NOT_EXIST: 'Error: Token Doesn\'t exist',
  TOKEN_EXPIRED: 'Error: This token has expired',
  UNKNOWN_ERROR: 'Error: An unknown error has ocurred',
};

export default errors;
